import { render, staticRenderFns } from "./CurrencySpinner.vue?vue&type=template&id=63462bc7&"
import script from "./CurrencySpinner.vue?vue&type=script&lang=js&"
export * from "./CurrencySpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports